var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:{ browsergame: _vm.isBrowserGame, momou: !_vm.isBrowserGame },attrs:{"id":"momou"}},[(!_vm.initiated)?_c('Init'):_vm._e(),(!_vm.installed && _vm.initiated)?_c('Install'):_vm._e(),(_vm.installed && _vm.initiated)?_c('Public'):_vm._e(),_c('Private'),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }